/* eslint-disable max-len */
const allProjects = [
  require("../../../provision/projects/understory tutorial/understory tutorial.json"),
  require("../../../provision/projects/understory tutorial 2/understory tutorial 2.json"),
  require("../../../provision/projects/understory tutorial 3/understory tutorial 3.json"),
  require("../../../provision/projects/understory tutorial 4/understory tutorial 4.json"),
  require("../../../provision/projects/blank project/blank project.json"),
  require("../../../provision/projects/zuzo-maze/zuzo-maze.json"),
  require("../../../provision/projects/muff-cave/muff-cave.json"),
  require("../../../provision/projects/chichi-chase/chichi-chase.json"),
  require("../../../provision/projects/bam-brew/bam-brew.json"),
];
let availableProjects = allProjects;

module.exports = availableProjects;
